import React from 'react';
import { motion } from 'framer-motion';

const AboutPage = () => {
  const aboutItems = [
    {
      id: 'mision',
      title: 'Misión',
      subtitle: 'Soluciones Inteligentes',
      description: 'Ofrecer soluciones innovadoras de calidad, garantizando la seguridad, eficiencia y durabilidad en cada proyecto. Estableciendo relaciones sólidas con nuestros clientes como su socio de confianza.',
      icon: 'próximamente'
    },
    {
      id: 'vision',
      title: 'Visión',
      subtitle: 'Opción #1',
      description: 'Aspiramos a ser reconocidos como líderes en la industria de proyectos industriales en Perú y a nivel internacional. Destacándonos por nuestra excelencia técnica, innovación constante y compromiso con la calidad y la satisfacción de clientes.',
      icon: 'próximamente'
    },
    {
      id: 'valores',
      title: 'Valores',
      subtitle: 'Excelencia Total',
      description: 'En DavidCorp, te ayudamos a generar valor a nuestros clientes a través de soluciones personalizadas y estamos comprometidos a garantizar:',
      list: ['INNOVACIÓN', 'CALIDAD', 'EFICIENCIA', 'PRECISIÓN'],
      icon: 'próximamente'
    }
  ];

  const certifications = [
    { 
      name: 'HODELPE SAC', 
      description: 'Proveedor Homologado por CORPORACIÓN HODELPE S.A.C. para FERREYROS S.A., tras superar rigurosamente el Proceso de Homologación de Proveedores con calificación destacada en todas las áreas evaluadas: información general, compliance, comercial, recursos humanos, legal y financiero.', 
      logo: '/assets/certificates/Homologacion Hodelpe icon.png',
      featured: true
    }
  ];

  const timeline = [
    {
      year: '2017',
      title: 'Fundación de DavidCorp',
      description: 'Nace DavidCorp S.R.L. en Perú, con la visión de ofrecer soluciones integrales en ingeniería, fabricación y montaje de estructuras metálicas.'
    },
    {
      year: '2025',
      title: 'Homologación HODELPE SAC',
      description: 'DavidCorp es calificado y homologado como proveedor por CORPORACIÓN HODELPE S.A.C. para FERREYROS S.A., obteniendo una calificación destacada en todas las áreas evaluadas.',
      highlight: true
    }
  ];

  const teamMembers = [
    {
      id: 'marcel-paredes',
      name: 'Marcel Paredes Rodríguez',
      position: 'Gerente de Operaciones',
      description: 'Ingeniero industrial con más de 35 años de experiencia en el sector industrial peruano. Ha liderado operaciones, proyectos de montaje y fabricación en empresas de reconocida trayectoria. Su sólida trayectoria en gestión operativa y supervisión de proyectos lo ha posicionado como un referente en la industria.',
      image: '/assets/equipo/marcel paredes.jpeg'
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white">
      {/* Hero Section */}
      <section className="py-32 bg-gradient-to-r from-primary-dark to-[#1a3a5f] text-white">
        <div className="container-standard px-4">
          <div className="max-w-4xl mx-auto text-center">
            <motion.h1 
              className="text-3xl md:text-4xl text-display font-bold mb-4"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
            >
              Sobre <span className="text-primary-accent">DavidCorp</span> S.R.L.
            </motion.h1>
            <motion.div
              className="w-20 h-1 bg-primary-accent mx-auto"
              initial={{ scaleX: 0 }}
              animate={{ scaleX: 1 }}
              transition={{ duration: 0.8, delay: 0.3 }}
            ></motion.div>
            <motion.p 
              className="mt-6 text-body-lg opacity-90 max-w-3xl mx-auto"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              Líderes en ingeniería, fabricación y soluciones industriales en Perú, con más de 5 años de experiencia entregando proyectos de alta calidad.
            </motion.p>
          </div>
        </div>
      </section>

      {/* Company Overview */}
      <section className="py-20">
        <div className="container-standard px-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              <h2 className="text-heading font-bold text-primary-dark mb-6">Nuestra Empresa</h2>
              <p className="text-body-lg text-gray-600 mb-6">
                DavidCorp S.R.L. es una empresa peruana especializada en ingeniería, fabricación y soluciones industriales. Desde nuestra fundación en 2020, hemos trabajado incansablemente para convertirnos en referentes en el sector industrial del Perú.
              </p>
              <p className="text-body-lg text-gray-600 mb-6">
                Nuestro compromiso con la excelencia, la seguridad y la calidad nos ha permitido construir relaciones duraderas con nuestros clientes, convirtiéndonos en su socio estratégico de confianza para proyectos de ingeniería e industriales.
              </p>
              <p className="text-body-lg text-gray-600">
                Con un equipo de profesionales altamente calificados y una sólida experiencia en diversos sectores industriales, ofrecemos soluciones integrales que abarcan desde el diseño conceptual hasta la puesta en marcha de proyectos llave en mano.
              </p>
            </motion.div>
            
            <motion.div
              className="bg-gray-100 rounded-2xl w-full h-96 flex items-center justify-center text-gray-500 overflow-hidden"
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              <div className="text-center p-4">
                <div className="text-4xl mb-2">🚧</div>
                <p className="text-sm font-medium">Próximamente</p>
                <p className="text-xs opacity-75 mt-1">Imagen representativa de la empresa</p>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-16 bg-gray-50">
        <div className="container-standard px-4">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5 }}
            >
              <div className="text-5xl font-bold text-primary-accent mb-2">200+</div>
              <p className="text-gray-600">Proyectos Completados</p>
            </motion.div>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.1 }}
            >
              <div className="text-5xl font-bold text-primary-accent mb-2">15+</div>
              <p className="text-gray-600">Años de Experiencia</p>
            </motion.div>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.2 }}
            >
              <div className="text-5xl font-bold text-primary-accent mb-2">50+</div>
              <p className="text-gray-600">Clientes Satisfechos</p>
            </motion.div>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.3 }}
            >
              <div className="text-5xl font-bold text-primary-accent mb-2">12</div>
              <p className="text-gray-600">Departamentos</p>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Mission, Vision, Values */}
      <section className="py-20 bg-gradient-to-b from-white to-gray-50">
        <div className="container-standard px-4">
          <motion.div
            className="text-center mb-16"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="text-heading font-bold text-primary-dark mb-4">Nuestra Identidad</h2>
            <div className="w-20 h-1 bg-primary-accent mx-auto"></div>
            <p className="mt-6 text-body-lg text-gray-600 max-w-3xl mx-auto">
              Nuestros principios guían cada decisión que tomamos y definen cómo creamos valor para nuestros clientes y colaboradores.
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {aboutItems.map((item, index) => (
              <motion.div
                key={item.id}
                className="bg-white rounded-2xl shadow-xl p-8 border border-gray-100 card-elevated flex flex-col"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                whileHover={{ y: -10, boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)' }}
              >
                <div className="flex justify-center mb-6">
                  {item.icon === 'próximamente' ? (
                    <div className="w-20 h-20 bg-primary-accent bg-opacity-10 rounded-full flex items-center justify-center text-gray-400">
                      <span className="text-xs text-center px-2">Próximamente</span>
                    </div>
                  ) : (
                    <img
                      src={item.icon}
                      alt={item.title}
                      className="w-12 h-12 object-contain"
                    />
                  )}
                </div>

                <h3 className="text-subheading font-bold text-center text-primary-dark mb-2">{item.title}</h3>
                <h4 className="text-lg font-semibold text-center text-primary-accent mb-4">{item.subtitle}</h4>

                <p className="text-gray-600 mb-4 text-center flex-grow">{item.description}</p>

                {item.list && (
                  <ul className="space-y-2 mt-4">
                    {item.list.map((value, idx) => (
                      <li
                        key={idx}
                        className="flex items-center text-gray-700 font-medium"
                      >
                        <span className="w-2 h-2 bg-primary-accent rounded-full mr-3"></span>
                        {value}
                      </li>
                    ))}
                  </ul>
                )}
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Company History Timeline */}
      <section className="py-20">
        <div className="container-standard px-4">
          <motion.div
            className="text-center mb-16"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="text-heading font-bold text-primary-dark mb-4">Nuestra Historia</h2>
            <div className="w-20 h-1 bg-primary-accent mx-auto"></div>
            <p className="mt-6 text-body-lg text-gray-600 max-w-3xl mx-auto">
              Hitos importantes que marcan nuestro crecimiento y compromiso con la excelencia.
            </p>
          </motion.div>

          {/* Timeline */}
          <div className="relative max-w-3xl mx-auto">
            {/* Vertical line */}
            <div className="absolute left-8 top-0 bottom-0 w-0.5 bg-primary-accent hidden md:block"></div>

            {timeline.map((item, index) => (
              <motion.div
                key={item.year}
                className="relative flex gap-6 mb-12 last:mb-0"
                initial={{ opacity: 0, x: -30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.2 }}
              >
                {/* Year badge */}
                <div className="flex-shrink-0 w-16">
                  <div className={`rounded-full w-16 h-16 flex items-center justify-center font-bold text-lg shadow-lg ${
                    item.highlight 
                      ? 'bg-gradient-to-br from-primary-accent to-primary-dark text-white' 
                      : 'bg-white border-2 border-primary-accent text-primary-dark'
                  }`}>
                    {item.year}
                  </div>
                </div>

                {/* Content */}
                <div className={`flex-1 pt-4 pb-6 px-6 rounded-xl border ${
                  item.highlight 
                    ? 'bg-gradient-to-r from-primary-dark/10 to-primary-accent/10 border-primary-accent/30 shadow-lg' 
                    : 'bg-white border-gray-200 shadow-md'
                }`}>
                  <h3 className="text-xl font-bold text-primary-dark mb-2">{item.title}</h3>
                  <p className="text-gray-600 leading-relaxed">{item.description}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Certifications */}
      <section className="py-20 bg-gradient-to-r from-primary-dark to-primary-accent text-white">
        <div className="container-standard px-4">
          <motion.div
            className="text-center mb-16"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="text-heading font-bold mb-4">Certificaciones y Reconocimientos</h2>
            <div className="w-20 h-1 bg-white mx-auto"></div>
            <p className="mt-6 text-body-lg opacity-90 max-w-3xl mx-auto">
              Nuestro compromiso con la calidad y el cumplimiento de estándares nos ha permitido ser reconocidos y homologados por las empresas más exigentes del sector.
            </p>
          </motion.div>

          {/* Featured Certification Card */}
          <div className="max-w-4xl mx-auto">
            {certifications.map((cert, index) => (
              <motion.div
                key={cert.name}
                className="bg-white rounded-2xl p-8 md:p-10 shadow-2xl"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                whileHover={{ y: -5, boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)' }}
              >
                <div className="flex flex-col md:flex-row items-center gap-8">
                  {/* Logo */}
                  <div className="flex-shrink-0">
                    {cert.logo ? (
                      <div className="bg-gradient-to-br from-primary-dark to-primary-accent rounded-xl p-6 shadow-lg">
                        <img 
                          src={cert.logo} 
                          alt={cert.name} 
                          className="h-24 w-auto object-contain" 
                        />
                      </div>
                    ) : (
                      <div className="text-6xl">🏆</div>
                    )}
                  </div>

                  {/* Content */}
                  <div className="flex-1 text-center md:text-left">
                    <div className="flex items-center justify-center md:justify-start gap-3 mb-3">
                      <span className="bg-gradient-to-r from-primary-dark to-primary-accent text-white text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wide">
                        Certificado
                      </span>
                    </div>
                    <h3 className="text-2xl md:text-3xl font-bold text-primary-dark mb-3">{cert.name}</h3>
                    <p className="text-gray-600 leading-relaxed">{cert.description}</p>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section className="py-20">
        <div className="container-standard px-4">
          <motion.div
            className="text-center mb-16"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="text-heading font-bold text-primary-dark mb-4">Nuestro Equipo</h2>
            <div className="w-20 h-1 bg-primary-accent mx-auto"></div>
            <p className="mt-6 text-body-lg text-gray-600 max-w-3xl mx-auto">
              Profesionales altamente calificados con años de experiencia en ingeniería e industrial solutions.
            </p>
          </motion.div>

          <div className="flex justify-center">
            {teamMembers.map((member, index) => (
              <motion.div
                key={member.id}
                className="group relative bg-white rounded-2xl shadow-xl overflow-hidden border border-gray-100 w-full max-w-lg"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                whileHover={{ y: -8, boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.15)' }}
              >
                {/* Image Container */}
                <div className="relative h-80 overflow-hidden bg-gradient-to-br from-primary-dark to-primary-accent">
                  {member.image === 'próximamente' ? (
                    <div className="absolute inset-0 flex items-center justify-center text-white">
                      <div className="text-center">
                        <div className="text-5xl mb-3 opacity-75">🚧</div>
                        <p className="text-sm font-medium opacity-75">Próximamente</p>
                      </div>
                    </div>
                  ) : (
                    <img
                      src={member.image}
                      alt={member.name}
                      className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                    />
                  )}
                  {/* Overlay gradient */}
                  <div className="absolute inset-0 bg-gradient-to-t from-primary-dark/90 via-primary-dark/20 to-transparent"></div>
                  {/* Name overlay on image */}
                  <div className="absolute bottom-0 left-0 right-0 p-6">
                    <h3 className="text-2xl font-bold text-white mb-1">{member.name}</h3>
                    <p className="text-primary-accent font-semibold text-sm uppercase tracking-wide">{member.position}</p>
                  </div>
                </div>
                {/* Description */}
                <div className="p-6 bg-white">
                  <p className="text-gray-600 leading-relaxed">
                    {member.description}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-20 bg-gradient-to-r from-primary-dark to-[#1a3a5f] text-white">
        <div className="container-standard px-4 text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="text-heading font-bold mb-4">¿Listo para comenzar su próximo proyecto?</h2>
            <p className="text-body-lg opacity-90 mb-8 max-w-2xl mx-auto">
              Contáctenos hoy mismo para discutir cómo podemos ayudarle a materializar su visión con soluciones de ingeniería e industriales de primera calidad.
            </p>
            <div className="flex flex-col sm:flex-row justify-center gap-4">
              <motion.button
                className="bg-primary-accent hover:bg-[#507d9c] text-white font-bold py-4 px-8 rounded-lg transition duration-300"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                Contáctenos
              </motion.button>
              <motion.button
                className="bg-transparent border-2 border-white text-white font-bold py-4 px-8 rounded-lg transition duration-300"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                Nuestros Servicios
              </motion.button>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default AboutPage;